import { Component,OnInit } from '@angular/core';
import { NavController, NavParams, 
        ToastController, AlertController,LoadingController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
//import { Market } from '@ionic-native/market';
import { HttpClient,HttpHeaders,HttpResponse } from '@angular/common/http';

//service
import { AppSharedService } from '../service/app_shared';

//types
import { LoginInfo,ConfigInfo} from '../model/types';

//page
import { RegisterPage } from '../register/register';
import { MenuPage } from  '../menu/menu';
import { ForgetpasswordPage } from '../forgetpassword/forgetpassword';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})

export class LoginPage implements OnInit {
 
  // class variable
  username:string;
  password:string;
  imageUrlResources  : string;
  currentAppVersion:number;

  // constrctuctor
  constructor(public navCtrl: NavController
              , public navParams: NavParams
              , public appSharedService:AppSharedService
              , public toastCtrl: ToastController
              , public storage: Storage 
              , public alertCtrl: AlertController
              , private http: HttpClient
              , public loadingCtrl : LoadingController
              //, private market: Market
            ) {
    
    // initialize
    this.username="";
    this.password="";
    this.imageUrlResources="";
    this.currentAppVersion=9;
  }
  
  //initialization
  ngOnInit() {
    this.GetApplicationInfo();
  }
  
  //get application info
  GetApplicationInfo(){
      
    //create loader
      //let loading = this.loadingCtrl.create({
      //  content: 'Please wait...'
      //});

      // show loader
      //loading.present();

      // do the service call
      //this.http.get('http://test.bazaarhub.co.in/api/common/getconfignew',{observe:'response'})
      //.subscribe((res: HttpResponse<any>) => {   
        //if(res.status==200){
          //if(res.body!=undefined && res.body!=null){
                 //this.appSharedService.configInfo=  res.body as ConfigInfo;
                 this.checkLogin();
                 this.imageUrlResources= this.appSharedService.configInfo.applicationInfo.fileBasePath+'/Images/AppResources/';
                 //loading.dismiss();
          //}
        //}else{
          //loading.dismiss();
        //}
      //}) 
    }
 
  // do the logins
 doLogin(){
      if(this.validateLogin())
      {
        //create loader 
        let loading = this.loadingCtrl.create({
          content: 'Please wait...'
        });

        //show loader
        loading.present();
        
        //clear user info
        this.appSharedService.clearUserLoginInfo();
        
        // initialize header
        let myheaders = new HttpHeaders();
        myheaders =myheaders.append("Authorization", "Basic " + btoa(this.username+":"+this.password));
        myheaders = myheaders.append("Content-Type", "application/x-www-form-urlencoded");
        
        //initialize url
        var url= (this.appSharedService.configInfo.applicationInfo.apiBasePath +'/' +this.appSharedService.configInfo.urlInfo.urlGetToken);
        
        // do the service call
        this.http.post(url, null,{headers : myheaders,observe:'response'})
        .subscribe((res: HttpResponse<any>) => {   
          if(res.status==200){
             // set login info
              var userinfo:LoginInfo ={           
                CustomerName: res.headers.get('CustomerName'),
                LocationName : res.headers.get('LocationName'),
                Token:res.headers.get('Token'),
                LocationId: Number(res.headers.get('LocationId')),
                TokenExpiry: res.headers.get('TokenExpiry'),
                UserId: Number(res.headers.get('UserId')),
              };
              // dismiss loader
              loading.dismiss();
              // initialize user info
              this.storage.set("bz_user_02",userinfo)
              .then(
                ()=>{
                  //this.usrService.saveFCMDetails(userinfo.UserId);
                  this.navCtrl.setRoot(MenuPage);
                }
              );
              
          }
          else{
            let message=this.appSharedService.getHttpResponseMessage(res,'Please enter valid username and password or make sure your account is approved by admin!');
            // dismiss loader
            loading.dismiss();
            
            // show alert
            this.alertCtrl.create({
              title: 'Error in login!',
              subTitle: message,
              buttons: ['OK']
            }).present();
          }
        }) 
      }
  }
 
  //check login
  checkLogin(){
  
   //if(this.appSharedService.configInfo.applicationInfo.currentAppVersion!=this.currentAppVersion){
    
   //  let message="New version of bazaarhub is available in play store. Please update to get better experience.";
    
   //  this.alertCtrl.create({
   //       title: 'Info',
   //       subTitle: message,
   //        buttons: ['OK']
   //      }).present();     
   //      this.market.open(this.appSharedService.configInfo.applicationInfo.googlePackageName);
   //}

    this.storage.get("bz_user_02").then((userinfo:LoginInfo) => {
          if(userinfo!=undefined && userinfo!=null && userinfo.Token!=undefined){
            this.navCtrl.setRoot(MenuPage);
          }
      }); 
  }
  
  //validate login
  validateLogin(){
    if(this.username.trim()=="" || this.password.trim()==""){
      this.toastCtrl.create({
        message: "Please enter  username and password",
        duration: 5000
      }).present();
      return false;
    }
    return true
  }
  
  //register page
  doRegister(){
    this.navCtrl.setRoot(RegisterPage);
  }
  forgetPassword(){
    this.navCtrl.setRoot(ForgetpasswordPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts